export default "__VITE_ASSET__DFO4fETW__"